/* eslint-disable */
import { Link } from './common.js';

export interface LinkData {
  /** Link details. */
  link?: Link;
}

const baseLinkData: object = {};

export const LinkData = {
  fromJSON(object: any): LinkData {
    const message = { ...baseLinkData } as LinkData;
    message.link =
      object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
    return message;
  },

  toJSON(message: LinkData): unknown {
    const obj: any = {};
    message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
    return obj;
  },
};
